import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { IEmailArticleProps } from '../types';
import { EmailArticle } from '../EmailArticle';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IEmailArticleProps = elementAttributesToProps(domNode);

  return Promise.resolve(<EmailArticle {...props} />);
};

export default rehydrator;
